import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import ImageCrop from '../image-crop/ImageCrop';

class ImageEditModal extends Component {
  static propTypes = {
    params: PropTypes.shape({
      imageFile: PropTypes.any,
      imageAspectRatio: PropTypes.number,
    }),
    onRequestClose: PropTypes.func,
  }

  state = {
    imageFile: undefined,
    imageAspectRatio: undefined,
    croppedImageFile: undefined,
  }

  static getDerivedStateFromProps(props, state) {
    console.log('from image edit modal')
    if (
      props.params.imageFile !== state.imageFile ||
      props.params.imageAspectRatio !== state.imageAspectRatio
    ) {
      return {
        ...state,
        imageFile: props.params.imageFile,
        imageAspectRatio: props.params.imageAspectRatio,
      }
    }
    return null
  }

  handleImageChange = file => {
    this.setState({ imageFile: file })
  }

  handleImageCrop = file => {
    this.setState({ croppedImageFile: file })
  }

  handleImageCropDefault = callback => {
    this.setState(
      {
        imageFile: undefined,
        croppedImageFile: undefined,
      },
      callback,
    )
  }

  handleRequestClose = () => {
    if (this.props.onRequestClose) {
      this.props.onRequestClose(null)
    }
  }

  isUploadable = () => this.state.imageFile !== undefined

  handleUpload = async () => {
    if (!this.isUploadable()) return

    if (this.props.onRequestClose) {
      this.props.onRequestClose({
        croppedImageFile: this.state.croppedImageFile,
        action: _.get(this.props, 'params.action')
      })
    }
  }
  render() {
    return (
      <div className="card">
        <header className="card-header">
          <p className="card-header-title">Edit Image</p>
          <a className="card-header-icon" aria-label="more options">
            <span className="icon">
              <i className="fas fa-angle-down" aria-hidden="true" />
            </span>
          </a>
        </header>
        <div className="card-content">
          <div className="content">
            {this.state.imageFile && (
              <ImageCrop
                imageAspectRatio={this.state.imageAspectRatio || 1}
                imageFile={this.state.imageFile}
                onImageCrop={this.handleImageCrop}
              />
            )}
          </div>
        </div>
        <footer className="card-footer">
          <a
            className="card-footer-item button is-white"
            onClick={this.handleRequestClose}
          >
            กลับ
          </a>
          {this.state.croppedImageFile && (
            <a
              className="card-footer-item button is-primary"
              onClick={this.handleUpload}
            >
              บันทึก
            </a>
          )}
        </footer>
      </div>
    )
  }
}

export default ImageEditModal



// WEBPACK FOOTER //
// ./src/modules/image/ImageEditModal.js